type StoragePayload<T> = {
  value: T;
  expireTs: number | null;
};

const localStorageAvailable = () => typeof localStorage !== 'undefined';

function safeJSONParse<T>(o: string | null | undefined): StoragePayload<T> | null {
  if (!o) {
    return null;
  }

  try {
    return JSON.parse(o);
  } catch (e) {
    return null;
  }
}

export function setInLocalStorage<T>(
  key: string,
  value: T,
  {
    ttl,
    date = Date.now(),
  }: {
    ttl: number;
    date?: number;
  } = {},
) {
  if (localStorageAvailable()) {
    const storagePayload = {
      value,
      expireTs: ttl ? date + ttl : null,
    };
    localStorage.setItem(key, JSON.stringify(storagePayload));
  }
}
export function remove(key: string) {
  if (localStorageAvailable()) {
    localStorage.removeItem(key);
  }
}
export function clearLocalStorage() {
  if (localStorageAvailable()) {
    localStorage.clear();
  }
}
export function getFromLocalStorage<T>(key: string, date: number = Date.now()): T | null {
  if (!localStorageAvailable()) {
    return null;
  }

  const { value, expireTs } = safeJSONParse<T>(localStorage.getItem(key)) ?? {};

  if (expireTs != null && expireTs <= date) {
    remove(key);
    return null;
  }

  return value ?? null;
}
